import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

const monthShort = (ym) => {
  // ym: "YYYY-MM"
  if (!ym) return "";
  const m = Number(String(ym).split("-")[1]);
  const labels = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return labels[m - 1] || ym;
};

export default function UserVenueBarChart({ data = [] }) {
  return (
    <div className="sa-uv-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 6, right: 8, left: 8, bottom: 0 }}>
          <CartesianGrid vertical={false} opacity={0.18} strokeDasharray="3 3" />

          <XAxis
            dataKey="period"
            tickFormatter={monthShort}
            axisLine={false}
            tickLine={false}
            tickMargin={10}
          />

          <Tooltip
            labelFormatter={(label) => `Month: ${label}`}
            formatter={(value, name) => [value, name === "newUsers" ? "New Users" : "New Venues"]}
          />

          {/* Users (primary) */}
          <Bar
            dataKey="newUsers"
            fill="currentColor"
            radius={[8, 8, 0, 0]}
            maxBarSize={32}
          />

          {/* Venues (secondary, lighter) */}
          <Bar
            dataKey="newVenues"
            fill="rgba(0,0,0,0.18)"
            radius={[8, 8, 0, 0]}
            maxBarSize={18}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
